import { computed } from "vue";
import { i18n } from "./../../i18n";
const { t } = i18n.global;

const menuItems = computed(() => [
    {
        slug: "start-page",
        path: "/",
        name: "Start Page",
        label: t("hubsystem.pages.menuItems.startPage.linkLabel"),
        children: [
            {
                path: "/start-page",
                name: "Start Overview",
                label: t("hubsystem.pages.menuItems.startPage.children.overview.linkLabel"),
            },
        ],
    },
]);

export { menuItems };
